import { type ActionEvent, Controller } from "@hotwired/stimulus"

import LoaderController from "@/controllers/loader_controller"

import { pushGa4StorageToDataLayer } from "@/helpers/ga4_helper"
import { isMobile } from "@/helpers/window_size"

export default class extends Controller {
  static outlets = ["page-loader"]
  declare readonly pageLoaderOutlet: LoaderController

  connect(): void {
    // We do this on `connect` rather than `initialize` because root element is a Turbo stream
    // target that gets replaced when filters change, which counts as new search page load.
    pushGa4StorageToDataLayer()
  }

  navigateWithLoader(e: ActionEvent): void {
    const link = e.target as HTMLAnchorElement

    // Always open links in current tab on mobile
    if (isMobile()) {
      link.removeAttribute("target")
    }

    if (!link.hasAttribute("target")) {
      this.pageLoaderOutlet.startWithId(this.identifier)
    }
  }
}
